import styled from 'styled-components';

const ChatPageLoading = styled.div`
  display: flex;
  justify-content: center;
`;

export default {
  ChatPageLoading,
};
